var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "16*16_\xEB\xA7\x90\xED\x92\x8D\xEC\x84\xA0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2C4.68633 2 2 4.68632 2 8C2 9.0359 2.26288 10.0121 2.72558 10.8633L2.28633 13.2259C2.27397 13.2926 2.27803 13.3614 2.29817 13.4262C2.31831 13.4911 2.35393 13.55 2.40194 13.5981C2.44995 13.6461 2.50892 13.6817 2.57376 13.7018C2.63861 13.722 2.70738 13.726 2.77414 13.7137L5.13674 13.2739C6.0153 13.7518 6.99983 14.0015 8 14C11.3137 14 14 11.3137 14 8C14 4.68632 11.3137 2 8 2ZM10.7907 7.30232C10.6057 7.30232 10.4282 7.37583 10.2974 7.50667C10.1665 7.63751 10.093 7.81496 10.093 8C10.093 8.18503 10.1665 8.36249 10.2974 8.49333C10.4282 8.62417 10.6057 8.69767 10.7907 8.69767C10.9757 8.69767 11.1532 8.62417 11.284 8.49333C11.4149 8.36249 11.4884 8.18503 11.4884 8C11.4884 7.81496 11.4149 7.63751 11.284 7.50667C11.1532 7.37583 10.9757 7.30232 10.7907 7.30232ZM7.30233 8C7.30233 7.81496 7.37583 7.63751 7.50667 7.50667C7.63751 7.37583 7.81497 7.30232 8 7.30232C8.18504 7.30232 8.36249 7.37583 8.49333 7.50667C8.62417 7.63751 8.69767 7.81496 8.69767 8C8.69767 8.18503 8.62417 8.36249 8.49333 8.49333C8.36249 8.62417 8.18504 8.69767 8 8.69767C7.81497 8.69767 7.63751 8.62417 7.50667 8.49333C7.37583 8.36249 7.30233 8.18503 7.30233 8ZM5.2093 7.30232C5.02427 7.30232 4.84681 7.37583 4.71597 7.50667C4.58513 7.63751 4.51163 7.81496 4.51163 8C4.51163 8.18503 4.58513 8.36249 4.71597 8.49333C4.84681 8.62417 5.02427 8.69767 5.2093 8.69767C5.39434 8.69767 5.57179 8.62417 5.70263 8.49333C5.83347 8.36249 5.90698 8.18503 5.90698 8C5.90698 7.81496 5.83347 7.63751 5.70263 7.50667C5.57179 7.37583 5.39434 7.30232 5.2093 7.30232Z",
    fill: "url(#paint0_linear_0_217)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_217",
    x1: 5.55556,
    y1: 1,
    x2: 17.0187,
    y2: 6.72039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7955F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3209B9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReply);
export default __webpack_public_path__ + "static/media/reply.0c0ab2c59f31de93e8e886bedd3eb024.svg";
export { ForwardRef as ReactComponent };